/**
 * Signup consent: persisted across web OAuth redirect via sessionStorage.
 */

export const OAUTH_SIGNUP_CONSENT_STORAGE_KEY = 'zporti_oauth_signup_consent_pending' as const

export interface OauthSignupConsentPending {
  marketingEmailOptIn: boolean
  legalTermsAccepted: boolean
}

export function parseOauthSignupConsentPending(raw: string | null): OauthSignupConsentPending | null {
  if (!raw || typeof raw !== 'string') return null
  try {
    const v = JSON.parse(raw) as unknown
    if (typeof v !== 'object' || v === null) return null
    const obj = v as Record<string, unknown>
    if (typeof obj.marketingEmailOptIn !== 'boolean') return null
    if (typeof obj.legalTermsAccepted !== 'boolean') return null
    return {
      marketingEmailOptIn: obj.marketingEmailOptIn,
      legalTermsAccepted: obj.legalTermsAccepted,
    }
  } catch {
    return null
  }
}
